var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 20.4349,
    rx: 20.5,
    ry: 20.4349,
    fill: "#FB7C51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.845 20.7776C31.845 20.5463 31.7067 20.3372 31.4935 20.2463L13.0475 12.3659C12.8364 12.2757 12.5919 12.3182 12.4238 12.4742C12.2558 12.6302 12.1959 12.8704 12.2712 13.0866L14.9469 20.7775L12.2711 28.4685C12.1982 28.6782 12.2523 28.9104 12.4089 29.0665C12.4138 29.0714 12.4187 29.0761 12.4238 29.0808C12.5919 29.2368 12.8364 29.2793 13.0474 29.1891L31.4935 21.3089C31.7067 21.2178 31.845 21.0088 31.845 20.7776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8426 20.7777L14.9446 20.7776L12.2688 28.4685C12.1958 28.6783 12.25 28.9105 12.4066 29.0666C12.4114 29.0714 12.4164 29.0762 12.4215 29.0809C12.5895 29.2369 12.834 29.2794 13.0451 29.1892L31.4911 21.309C31.7043 21.2179 31.8426 21.0089 31.8426 20.7777Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon2);
export default __webpack_public_path__ + "static/media/SendIcon2.67482cb487fcec643946b938315fb1df.svg";
export { ForwardRef as ReactComponent };